import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { clearNotificationStatus, setNotificationStatus } from '../../../redux/notifier/notifierReducer';
import useImagesGenerationStatus from '../../hooks/useImagesGenerationStatus';
import useCardGenerationSocketStats from '../../hooks/useCardGenerationSocketStats';
import { addPromptToImages, getPromptById } from '../../../redux/id8/id8Actions';
import { changeActiveGenStatus, changeGeneratingStatusForPrompt } from '../../../redux/id8/id8Reducer';
import { ID8_GEN_TYPES, PROMPT_TYPE } from '../../../constants';
import callApi from '../../../service/callApi';

function ImagesGeneratingStatusController({ promptType, generationLabel }) {
  const dispatch = useDispatch();
  const { id: projectId } = useParams();

  const checkStatus = async (projectId) => {
    const response = await callApi.get(
      `/api/project/status/is/id8/content/generating?id=${projectId}&contentType=${promptType}`,
    );

    dispatch(changeActiveGenStatus({ genType: mappedPromptTypeToGenType[promptType], status: response.data }));
  };

  useCardGenerationSocketStats(projectId, promptType, {
    onCreated: (frameId) => {
      dispatch(addPromptToImages({ promptId: frameId, promptType }));
    },
    onGeneratingStart: (frameId) => {
      dispatch(changeGeneratingStatusForPrompt({ id: frameId, generating: true, promptType }));
    },
    onGeneratingFinish: (frameId) => {
      dispatch(changeGeneratingStatusForPrompt({ id: frameId, generating: false, promptType }));
    },
    onImageGenerated: ({ bucketId }) => {
      dispatch(getPromptById({ bucketId, promptType }));
    },
    onAllImagesGenerated: () => {
      dispatch(changeActiveGenStatus({ genType: mappedPromptTypeToGenType[promptType], status: false }));
    },
  });

  const isImagesGenerating = useImagesGenerationStatus({ genType: mappedPromptTypeToGenType[promptType] });

  useEffect(() => {
    if (isImagesGenerating) {
      dispatch(setNotificationStatus(generationLabel ?? 'generationInProgress'));
    } else {
      dispatch(clearNotificationStatus());
    }

    return () => {
      dispatch(clearNotificationStatus());
    };
  }, [isImagesGenerating, generationLabel, dispatch]);

  useEffect(() => {
    checkStatus(projectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return null;
}

export default ImagesGeneratingStatusController;

const mappedPromptTypeToGenType = {
  [PROMPT_TYPE.IDEA]: ID8_GEN_TYPES.IMAGES,
  [PROMPT_TYPE.RECREATE]: ID8_GEN_TYPES.RECREATE,
};
